var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),(_vm.isLoading)?_c('ajax-spinner'):_vm._e(),_vm._v(" "),_c('error-modal-container')],2)}
var staticRenderFns = []

export { render, staticRenderFns }